module.exports = __webpack_public_path__ + "static/media/noticias.406225ba.svg";